import { render, staticRenderFns } from "./VInventoryItemFields.vue?vue&type=template&id=61029381"
import script from "./VInventoryItemFields.vue?vue&type=script&lang=js"
export * from "./VInventoryItemFields.vue?vue&type=script&lang=js"
import style0 from "./VInventoryItemFields.vue?vue&type=style&index=0&id=61029381&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports